<script setup>
import { ref } from "vue";
import { Popover, PopoverTrigger, PopoverContent } from "@/shared/ui/popover";
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";

const props = defineProps({
  editor: {
    type: Object,
    required: true,
  },
});

const GRID_SIZE = 8;

const hoveredRow = ref(0);
const hoveredCol = ref(0);
const isOpen = ref(false);

function onCellHover(row, col) {
  hoveredRow.value = row;
  hoveredCol.value = col;
}

function onCellClick(row, col) {
  props.editor
    .chain()
    .focus()
    .insertTable({ rows: row, cols: col, withHeaderRow: false })
    .run();
  isOpen.value = false;
}

function isHighlighted(row, col) {
  return row <= hoveredRow.value && col <= hoveredCol.value;
}

function resetHover() {
  hoveredRow.value = 0;
  hoveredCol.value = 0;
}
</script>

<template>
  <Popover v-model:open="isOpen">
    <PopoverTrigger as-child>
      <button
        class="inline-flex items-center justify-center rounded-md text-sm font-medium h-8 px-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
      >
        <svg-icon name="huge-editor-table" class="w-4 h-4 text-foreground" />
      </button>
    </PopoverTrigger>

    <PopoverContent class="w-auto p-3" align="start">
      <div @mouseleave="resetHover">
        <div
          v-for="row in GRID_SIZE"
          :key="row"
          class="flex gap-0.5"
          :class="{ 'mt-0.5': row > 1 }"
        >
          <div
            v-for="col in GRID_SIZE"
            :key="col"
            class="w-5 h-5 border rounded-sm transition-colors duration-100 cursor-pointer"
            :class="
              isHighlighted(row, col)
                ? 'bg-primary/20 border-primary/40'
                : 'bg-background border-border'
            "
            @mouseenter="onCellHover(row, col)"
            @click="onCellClick(row, col)"
          />
        </div>
      </div>

      <div class="mt-2 text-center text-xs text-muted-foreground">
        {{
          hoveredRow && hoveredCol
            ? `${hoveredRow} × ${hoveredCol}`
            : "Выберите размер"
        }}
      </div>
    </PopoverContent>
  </Popover>
</template>
